<style lang="less">
@import "./home.less";
@import "../../styles/common.less";
</style>

<template>
    <div style="text-align: center;margin-top: 25%;">
        <h1>欢迎使用中国时尚知识产权保护中心管理后台</h1>
        <!--<div v-show="currNav=='hatch'">-->
            <!--<Tabs value="name1" @on-click="setBz">-->
                <!--<TabPane label="版权方" name="name1">-->
                    <!--<Row :gutter="10">-->
                        <!--<Col v-if="bz==456" :md="24" :lg="24">-->
                            <!--<Row :lazy="true" :gutter="5">-->
                                <!--<Col :xs="24" :sm="12" :md="8" :style="{marginBottom: '10px'}">-->
                                <!--<infor-card id-name="user_created_count" :end-val="bcount.yesterdayIncomeTotal" iconType="md-person-add" color="#2d8cf0" intro-text="昨日收益"></infor-card>-->
                                <!--</Col>-->
                                <!--<Col :xs="24" :sm="12" :md="8" :style="{marginBottom: '10px'}">-->
                                <!--<infor-card number="2" id-name="visit_count" :end-val-two="bcount.yesterdayPlayCountTotal" :end-val="bcount.copyrightTotal" iconType="ios-eye" color="#64d572" :iconSize="50" intro-text="版权数量" intro-text-two="昨日播放量"></infor-card>-->
                                <!--</Col>-->
                                <!--<Col :xs="24" :sm="12" :md="8" :style="{marginBottom: '10px'}">-->
                                <!--<infor-card number="2" id-name="collection_count" :end-val-two="bcount.playCountTotal" :end-val="bcount.incomeTotal" iconType="md-cloud-upload" color="#ffd572" intro-text="总收益"  intro-text-two="总播放量"></infor-card>-->
                                <!--</Col>-->
                            <!--</Row>-->
                            <!--<Row style="width:100%;background:#fff">-->
                                <!--<Col :md="24" :lg="24" style="padding: 20px;" >-->
                                    <!--<div>-->
                                        <!--最近收益曲线-->
                                        <!--<Select @on-change="numberDayChange(model1)" v-model="model1" placeholder="请选择天数" style="width: 200px;margin-left:50px;">-->
                                            <!--<Option v-for="(item, i) in dictTime" :key="i" :value="item.value">{{item.title}}</Option>-->
                                        <!--</Select>-->
                                    <!--</div>-->
                                <!--</Col>-->
                                <!--<Col :lazy="true" :md="24" :lg="24" :style="{background:'#fff',padding: '20px',display:myHeightHomeLine==0?'none':'block',width:'100%'}" >-->
                                    <!--<tort-line-chart id="tortlinehomeSy" :bz="bz" ref="tortlinehomeSy" :numberD="numberD" type="line1" :lengend="lengendHomeLine" :xAxis="xAxisHomeLine" :series="seriesHomeLine" :maxVal="maxValHomeLine"></tort-line-chart>-->
                                <!--</Col>-->
                                <!--<Col :lazy="true" :md="24" :lg="24" :style="{background:'#fff',padding: '20px 0 10px 50px',width:'100%',display:myQqHomeHeightPie==0?'none':'block'}">-->
                                    <!--<div>-->
                                        <!--&lt;!&ndash; <line-chart></line-chart> &ndash;&gt;-->
                                        <!--<tort-chart ref='tortChartsQqHome' :bz="bz" :numberD="numberD" id="tortChartsQqHome" title="侵权分布统计饼图" :legend="lengendQqHomePie" :series="seriesQqHomePie"></tort-chart>-->
                                    <!--</div>-->
                                <!--</Col>-->
                                <!--<Col :lazy="true" :md="24" :lg="24" :style="{background:'#fff',padding: '20px',display:myQqHomeHeightLine==0?'none':'block'}" >-->
                                    <!--<tort-line-chart id="tortlinehomeQq" :bz="bz" ref="tortlinehomeQq" :numberD="numberD" :lengend="lengendQqHomeLine" :xAxis="xAxisQqHomeLine" :series="seriesQqHomeLine" :maxVal="maxValQqHomeLine"></tort-line-chart>-->
                                <!--</Col>-->
                            <!--</Row>-->
                        <!--</Col>-->
                    <!--</Row>-->
                <!--</TabPane>-->
                <!--&lt;!&ndash; <TabPane label="自媒体" name="name2">-->
                    <!--<Row :gutter="10">-->
                        <!--<Col v-if="bz==123" :md="24" :lg="24">-->
                            <!--<Row :lazy="true" :gutter="5">-->
                                <!--<Col :xs="24" :sm="12" :md="8" :style="{marginBottom: '10px'}">-->
                                <!--<infor-card id-name="user_created_count" :end-val="count.yesterdayIncomeTotal" iconType="md-person-add" color="#2d8cf0" intro-text="昨日收益"></infor-card>-->
                                <!--</Col>-->
                                <!--<Col :xs="24" :sm="12" :md="8" :style="{marginBottom: '10px'}">-->
                                <!--<infor-card id-name="visit_count" :end-val="count.accountTotal" iconType="ios-eye" color="#64d572" :iconSize="50" intro-text="运营账号数量"></infor-card>-->
                                <!--</Col>-->
                                <!--<Col :xs="24" :sm="12" :md="8" :style="{marginBottom: '10px'}">-->
                                <!--<infor-card id-name="collection_count" :end-val="count.incomeTotal" iconType="md-cloud-upload" color="#ffd572" intro-text="全部收益"></infor-card>-->
                                <!--</Col>-->
                                <!--<Col :xs="24" :sm="12" :md="6" :style="{marginBottom: '10px'}">-->
                                <!--<infor-card id-name="transfer_count" :end-val="count.transfer" iconType="md-shuffle" color="#f25e43" intro-text="今日服务调用量"></infor-card>-->
                                <!--</Col>-->
                            <!--</Row>-->
                            <!--<Row style="background:#fff">-->
                                <!--<Col :md="24" :lg="24" style="padding: 20px;" >-->
                                    <!--<div>-->
                                        <!--最近收益曲线-->
                                        <!--<Select @on-change="numberDayChange(model1)" v-model="model1" placeholder="请选择天数" style="width: 200px;margin-left:50px;">-->
                                            <!--<Option v-for="(item, i) in dictTime" :key="i" :value="item.value">{{item.title}}</Option>-->
                                        <!--</Select>-->
                                    <!--</div>-->
                                <!--</Col>-->
                                <!--<Col :lazy="true" :md="24" :lg="24" :style="{background:'#fff',padding: '20px',display:myWemediaLineHeight==0?'none':'block'}" >-->
                                    <!--<tort-line-chart id="tlchartWemediaLine" :lengend="lengendWemediaLine" :xAxis="xAxisWemediaLine" :series="seriesWemediaLine" :maxVal="maxValWemediaLine" type="line1" :bz="bz" ref="tlchartWemediaLine" :numberD="numberD"></tort-line-chart>-->
                                <!--</Col>-->
                                <!--<Col :lazy="true" :md="24" :lg="12" :style="{background:'#fff',padding: '20px 0 10px 50px',display:myWeCounHeightPie==0?'none':'block'}">-->
                                    <!--<div>-->
                                        <!--<tort-chart :legend="lengendWeCounPie" :series="seriesWeCounPie" :bz="bz" :numberD="numberD" ref="tortWeCounChart" id="tortWeCounChart" title="账号分布情况" type="yuans1"></tort-chart>-->
                                    <!--</div>-->
                                <!--</Col>-->
                                <!--<Col :lazy="true" :md="24" :lg="12" :style="{background:'#fff',padding: '20px 5px 10px 50px',display:myWeIncomeHeightPie==0?'none':'block'}">-->
                                    <!--<div>-->
                                        <!--<tort-chart ref="tortWeIncomeChart" :legend="lengendWeIncomePie" :series="seriesWeIncomePie" :bz="bz" :numberD="numberD" id="tortWeIncomeChart" title="收益占比" type="yuans2"></tort-chart>-->
                                    <!--</div>-->
                                <!--</Col>-->
                            <!--</Row>-->
                        <!--</Col>-->
                    <!--</Row>-->
                <!--</TabPane> &ndash;&gt;-->
            <!--</Tabs>-->
        <!--</div>-->
    </div>
</template>

<script>
import { ipInfo, wemediaTotalGetTotal, copyrightTotalGetTotal } from "@/api/index";
import cityData from "./map-data/get-city-value.js";
import homeMap from "./components/map.vue";
import visiteVolume from "./components/visiteVolume.vue";
import lineChart from "./components/lineChart.vue"; 
import tortChart from "./components/tortChart.vue";
import tortLineChart from "./components/tortLineChart.vue"; 
import userFlow from "./components/userFlow.vue";
import countUp from "./components/countUp.vue";
import inforCard from "./components/inforCard.vue";
import mapDataTable from "./components/mapDataTable.vue";
import show from "./show.vue";
import Cookies from "js-cookie";
import "gitalk/dist/gitalk.css";
import Gitalk from "gitalk";

export default {
  name: "home",
  components: {
    homeMap,
    visiteVolume,
    lineChart,
    tortChart,
    userFlow,
    countUp,
    inforCard,
    mapDataTable,
    tortLineChart,
    show
  },
  data() {
    return {
        myWeIncomeHeightPie:1,
        lengendWeIncomePie:[],
        seriesWeIncomePie:[],
        myWeCounHeightPie:1,
        lengendWeCounPie:[],
        seriesWeCounPie:[],
        myWemediaLineHeight:1,// 上面是自媒体
        lengendWemediaLine:[],
        xAxisWemediaLine:[],
        seriesWemediaLine:[],
        maxValWemediaLine:'',
        myQqHomeHeightPie:1,
        lengendQqHomePie:['今日头条','趣头条','网易新闻','一点资讯','百家号','爱奇艺号','优酷视频','Bilibili','UC大鱼号','其他'],
        seriesQqHomePie:[{value:7335, name:'今日头条'},
     {value:5310, name:'趣头条'},
     {value:1234, name:'网易新闻'},
     {value:3147, name:'一点资讯'},
     {value:1548, name:'百家号'},
     {value:1335, name:'爱奇艺号'},
     {value:2303, name:'优酷视频'},
     {value:635, name:'Bilibili'},
     {value:4339, name:'UC大鱼号'},
     {value:2351, name:'其他'}],
        myQqHomeHeightLine:1,
        // 首页版权方的侵权折线图
        lengendQqHomeLine:[],
        xAxisQqHomeLine:[],
        seriesQqHomeLine:[{
            name:'侵权连接数',
            type:'line',
            data:[1324,1008, 940, 726, 1232, 560, 1670]
        }],
        maxValQqHomeLine:'2500',
        myHeightHomeLine:1,
        // 首页版权方的折线图数据
        lengendHomeLine:[],
        xAxisHomeLine:[],
        seriesHomeLine:[{
              name:'收益',
              type:'line',
              data:[17324,18008, 19409, 15726, 19232, 15606, 16702]
          }],
        maxValHomeLine:'25000',
        seriesLinesum:[{
            name:'收益',
            type:'line',
            data:[12000, 14900, 17000, 12320, 12560, 17670, 13500, 16204, 13260, 18217, 16405, 11338, 12083, 14970, 14705, 12893, 18256, 17627, 19356, 16022, 18326, 18200, 14105, 17324,18008, 19409, 15726, 19232, 15606, 16702]
        }],
      showVideo: false,
      count: {
          yesterdayIncomeTotal:0,
          accountTotal:0,
          incomeTotal:0,
      },
      bcount:{
          copyrightTotal: 485,
          incomeTotal: 473924,
          playCountTotal: 84264135,
          yesterdayIncomeTotal: 1670,
          yesterdayPlayCountTotal: 3687802,
      },
      cityData: cityData,
      newToDoItemValue: "",
      city: "",
      weather: "",
      username: "",
      dictTime:[
         {value:'7',title:'七天'},
         {value:'14',title:'十四天'}, 
         {value:'30',title:'三十天'}, 
      ],
      model1:'7',
      numberD:'7',
      bz:456,
    };
  },
  computed: {
    currNav() {
      return this.$store.state.app.currNav;
    },
    avatarPath() {
      return localStorage.avatorImgPath;
    }
  },
  methods: {
    // 首页自媒体收益占比图
    getWemeIncomList(){
        let _this = this;
        this.$nextTick(() => {
            _this.getRequest("/wemediaTotal/getWemediaIncomePie",{}).then(res => {
                if(Object.keys(res).length>0){
                    _this.myWeIncomeHeightPie = 1;
                    _this.lengendWeIncomePie = res.legend
                    _this.seriesWeIncomePie = res.series
                    _this.$set(_this.lengendWeIncomePie,_this.lengendWeIncomePie,res.legend)
                    _this.$set(_this.seriesWeIncomePie,_this.seriesWeIncomePie,res.series)
                    _this.$nextTick(() => {  
                        _this.$refs.tortWeIncomeChart.tortChart();
                    })
                }else{
                    _this.myWeIncomeHeightPie = 0;
                }
            });
        })
    },
    // 首页自媒体账户分布图
    getCountWemediaList(){
        let _this = this;
        this.$nextTick(() => {
            _this.getRequest("/wemediaTotal/getWemediaAccountPie",{}).then(res => {
                if(Object.keys(res).length>0){
                    _this.myWeCounHeightPie = 1;
                    _this.lengendWeCounPie = res.legend
                    _this.seriesWeCounPie = res.series
                    _this.$set(_this.lengendWeCounPie,_this.lengendWeCounPie,res.legend)
                    _this.$set(_this.seriesWeCounPie,_this.seriesWeCounPie,res.series)
                    _this.$nextTick(() => {  
                        _this.$refs.tortWeCounChart.tortChart();
                    })
                }else{
                    _this.myWeCounHeightPie = 0;
                }
            });
        })
    },
    // 首页自媒体收益分析折线图
    getWemediaChartList(){
        let _this = this;
        _this.$nextTick(() => {
            _this.getRequest("/wemediaTotal/getWemediaIncomeBrokenLine",{dayNum:this.numberD}).then(res => {
                console.log(res)
                if(Object.keys(res).length>0){
                    _this.myWemediaLineHeight = 1;
                    _this.lengendWemediaLine = res.legend
                    _this.xAxisWemediaLine = res.xAxis
                    _this.seriesWemediaLine =   res.series
                    _this.maxValWemediaLine =   res.maxVal
                    _this.$set(_this.lengendWemediaLine,_this.lengendWemediaLine,res.legend)
                    _this.$set(_this.xAxisWemediaLine,_this.xAxisWemediaLine,res.xAxis)
                    _this.$set(_this.seriesWemediaLine,_this.seriesWemediaLine,res.series)
                    _this.$nextTick(() => {  
                    _this.$refs.tlchartWemediaLine.tortChart();
                    })
                }else{
                    _this.myWemediaLineHeight = 0;
                }
            });
        })
    },
    // 首页版权方收益分析折线图
    getBqChartListSy(){
        let _this = this;
        _this.$nextTick(() => {
          let params = {
              dayNum:_this.numberD
          }
          _this.$nextTick(() => {  
                _this.$refs.tortlinehomeSy.tortChart();
            })
        //   _this.getRequest("/copyrightTotal/getCopyrightIncomeBrokenLine",params).then(res => {
        //       console.log(res)
        //       if(Object.keys(res).length>0){
        //         _this.myHeightHomeLine = 1;
        //         _this.lengendHomeLine = res.legend
        //         _this.xAxisHomeLine = res.xAxis
        //         _this.seriesHomeLine =   res.series
        //         _this.maxValHomeLine =   res.maxVal
        //         _this.$set(_this.lengendHomeLine,_this.lengendHomeLine,res.legend)
        //         _this.$set(_this.xAxisHomeLine,_this.xAxisHomeLine,res.xAxis)
        //         _this.$set(_this.seriesHomeLine,_this.seriesHomeLine,res.series)
        //         _this.$nextTick(() => {  
        //           _this.$refs.tortlinehomeSy.tortChart();
        //         })
        //       }else{
        //           _this.myHeightHomeLine = 0;
        //       }
        //   });
        })
    },
    // 首页侵权分析调用折线图
    getMonChartListQq(){
        let _this = this;
        this.$nextTick(() => {
            let params = {
                dayNum:this.numberD,
            }
            _this.$nextTick(() => {  
                _this.$refs.tortlinehomeQq.tortChart();
            })
            // _this.getRequest("/monitorTotal/getMonitorBrokenLine",params).then(res => {
            //     console.log(res)
            //     if(Object.keys(res).length>0){
            //       _this.myQqHomeHeightLine = 1;
            //       _this.lengendQqHomeLine = res.legend
            //       _this.xAxisQqHomeLine = res.xAxis
            //       _this.seriesQqHomeLine =   res.series
            //       _this.maxValQqHomeLine =   res.maxVal
            //       _this.$set(_this.lengendQqHomeLine,_this.lengendQqHomeLine,res.legend)
            //       _this.$set(_this.xAxisQqHomeLine,_this.xAxisQqHomeLine,res.xAxis)
            //       _this.$set(_this.seriesQqHomeLine,_this.seriesQqHomeLine,res.series)
            //       _this.$nextTick(() => {  
            //         _this.$refs.tortlinehomeQq.tortChart();
            //       })
            //     }else{
            //         _this.myQqHomeHeightLine = 0;
            //     }
            // });
        })
    },
    // 首页侵权分析调用饼状图
    getKsChartListQs(){
        let _this = this;
        this.$nextTick(() => {
            let params = {
                copyrightName:this.copyrightNameD,
            }
            if(!this.copyrightNameD){
                delete params.copyrightName
            }
            _this.$nextTick(() => {
                _this.$refs.tortChartsQqHome.tortChart();
            })
            // _this.getRequest("/monitorTotal/getCopyrightIncomePie",params).then(res => {
            //     if(Object.keys(res).length>0){
            //         _this.myQqHomeHeightPie = 1;
            //         _this.lengendQqHomePie = res.legend
            //         _this.seriesQqHomePie = res.series
            //         _this.$set(_this.lengendQqHomePie,_this.lengendQqHomePie,res.legend)
            //         _this.$set(_this.seriesQqHomePie,_this.seriesQqHomePie,res.series)
            //         _this.$nextTick(() => {
            //           _this.$refs.tortChartsQqHome.tortChart();
            //         })
            //     }else{
            //         _this.myQqHomeHeightPie = 0;
            //     }
            // });
        })
    },
    setBz(name){
        if(name=='name1'){
            this.bz = 456
            this.getKsChartListQs()
            this.getBqChartListSy()
            this.getMonChartListQq();
            // copyrightTotalGetTotal().then(res => {
            //     console.log('++++++++++++++++++++++',res)
            //     let incomeTotal = res.incomeTotal == '' || res.incomeTotal == null || res.incomeTotal == undefined ? 0 :res.incomeTotal;
            //     let copyrightTotal = res.copyrightTotal == '' || res.copyrightTotal == null || res.copyrightTotal == undefined ? 0 :res.copyrightTotal;
            //     let playCountTotal = res.playCountTotal == '' || res.playCountTotal == null || res.playCountTotal == undefined ? 0 :res.playCountTotal;
            //     let yesterdayIncomeTotal = res.yesterdayIncomeTotal == '' || res.yesterdayIncomeTotal == null || res.yesterdayIncomeTotal == undefined ? 0 :res.yesterdayIncomeTotal;
            //     let yesterdayPlayCountTotal = res.yesterdayPlayCountTotal == '' || res.yesterdayPlayCountTotal == null || res.yesterdayPlayCountTotal == undefined ? 0 :res.yesterdayPlayCountTotal;
            //         this.$set(this.bcount,'incomeTotal',incomeTotal)
            //         this.$set(this.bcount,'copyrightTotal',copyrightTotal)
            //         this.$set(this.bcount,'playCountTotal',playCountTotal)
            //         this.$set(this.bcount,'yesterdayIncomeTotal',yesterdayIncomeTotal)
            //         this.$set(this.bcount,'yesterdayPlayCountTotal',yesterdayPlayCountTotal)
            // })
        }else{
            this.bz = 123
             wemediaTotalGetTotal().then(res => {
                this.count.yesterdayIncomeTotal = res.yesterdayIncomeTotal == '' || res.yesterdayIncomeTotal == null || res.yesterdayIncomeTotal == undefined ? 0 :res.yesterdayIncomeTotal;
                this.count.accountTotal = res.accountTotal == '' || res.accountTotal == null || res.accountTotal == undefined ? 0 :res.accountTotal;
                this.count.incomeTotal = res.incomeTotal == '' || res.incomeTotal == null || res.incomeTotal == undefined ? 0 :res.incomeTotal;
            })
            this.getWemediaChartList();
            this.getCountWemediaList();
            this.getWemeIncomList();
        }
    },
    time(date){
        var y = date.getFullYear();  
        var m = date.getMonth() + 1;  
        m = m < 10 ? '0' + m : m;  
        var d = date.getDate();  
        d = d < 10 ? ('0' + d) : d;  
        return y + '-' + m + '-' + d;  
    },
    // 自动获取时间的函数
    getAutoDate(number){
      let dateArray = []
      for(let i=0;i<number;i++){
        dateArray
        .unshift(this.time(new Date(new Date()
           .setDate(new Date().getDate()-i))
           ))
      }
      return dateArray
      console.log('+++++++++++++++++',dateArray)
    },
    init() {
      if (localStorage.cachePage) {
           this.$store.state.app.cachePage.length = 0;
        }
        this.setBz('name1')
        this.xAxisHomeLine = this.getAutoDate(7)
        this.xAxisQqHomeLine = this.getAutoDate(7)
      let userInfo = JSON.parse(Cookies.get("userInfo"));
      this.username = userInfo.username;
      if(this.bz == 123){
          this.getWemediaChartList();
        //   wemediaTotalGetTotal().then(res => {
        //     this.count.yesterdayIncomeTotal = res.yesterdayIncomeTotal == '' || res.yesterdayIncomeTotal == null || res.yesterdayIncomeTotal == undefined ? 0 :res.yesterdayIncomeTotal;
        //     this.count.accountTotal = res.accountTotal == '' || res.accountTotal == null || res.accountTotal == undefined ? 0 :res.accountTotal;
        //     this.count.incomeTotal = res.incomeTotal == '' || res.incomeTotal == null || res.incomeTotal == undefined ? 0 :res.incomeTotal;
        // })
        this.getCountWemediaList();
        this.getWemeIncomList();
      }else{
          let yesterdayTime = this.time(new Date())
            let tempYes = this.xAxisHomeLine
            let sumLength = this.seriesLinesum[0].data.length - tempYes.length;
            for(let i = 0;i<tempYes.length;i++){
            if(tempYes[i] == yesterdayTime){
            if(sumLength+i-1>=0){
                this.bcount.yesterdayIncomeTotal = this.seriesLinesum[0].data[sumLength+i-1]
                this.$set(this.bcount,'yesterdayIncomeTotal',this.seriesLinesum[0].data[sumLength+i-1])
            }else{
                this.bcount.yesterdayIncomeTotal = 0
                this.$set(this.bcount,'yesterdayIncomeTotal',0)
            }
            }
            }
          this.getKsChartListQs()
          this.getBqChartListSy()
          this.getMonChartListQq();
        //   copyrightTotalGetTotal().then(res => {
        //       console.log('++++++++++++++++++++++',res)
        //       let incomeTotal = res.incomeTotal == '' || res.incomeTotal == null || res.incomeTotal == undefined ? 0 :res.incomeTotal;
        //       let copyrightTotal = res.copyrightTotal == '' || res.copyrightTotal == null || res.copyrightTotal == undefined ? 0 :res.copyrightTotal;
        //       let playCountTotal = res.playCountTotal == '' || res.playCountTotal == null || res.playCountTotal == undefined ? 0 :res.playCountTotal;
        //       let yesterdayIncomeTotal = res.yesterdayIncomeTotal == '' || res.yesterdayIncomeTotal == null || res.yesterdayIncomeTotal == undefined ? 0 :res.yesterdayIncomeTotal;
        //       let yesterdayPlayCountTotal = res.yesterdayPlayCountTotal == '' || res.yesterdayPlayCountTotal == null || res.yesterdayPlayCountTotal == undefined ? 0 :res.yesterdayPlayCountTotal;
        //         this.$set(this.bcount,'incomeTotal',incomeTotal)
        //         this.$set(this.bcount,'copyrightTotal',copyrightTotal)
        //         this.$set(this.bcount,'playCountTotal',playCountTotal)
        //         this.$set(this.bcount,'yesterdayIncomeTotal',yesterdayIncomeTotal)
        //         this.$set(this.bcount,'yesterdayPlayCountTotal',yesterdayPlayCountTotal)
        //   })
      }
      
      // ipInfo().then(res => {
      //   if (res.success) {
      //     if(!res.result){
      //         return
      //     }
      //     let ipInfo = JSON.parse(res.result);
      //     if (ipInfo.retCode == "200") {
      //       let info = ipInfo.result[0];
      //       let weather =
      //         info.weather +
      //         " " +
      //         info.temperature +
      //         " 污染指数: " +
      //         info.pollutionIndex;
      //       this.city = info.city;
      //       this.weather = weather;
      //     } else {
      //       this.city = "未知";
      //       this.weather = "未知";
      //     }
      //   }
      // });
    },
    numberDayChange(v){
        this.numberD = v
        if(this.bz == '123'){
            this.getWemediaChartList();
        }else{
            switch(this.numberD){
                case '7':
                this.xAxisQqHomeLine=this.getAutoDate(7)
                this.seriesQqHomeLine=[{
                    name:'侵权连接',
                    type:'line',
                    data:[1324,1008, 940, 726, 1232, 560, 1670]
                }];
                this.xAxisHomeLine=this.getAutoDate(7)
                this.seriesHomeLine=[{
                    name:'收益',
                    type:'line',
                    data:[17324,18008, 19409, 15726, 19232, 15606, 16702]
                }];
                break;
                case '14':
                this.xAxisQqHomeLine=this.getAutoDate(14)
                this.seriesQqHomeLine=[{
                    name:'侵权连接',
                    type:'line',
                    data:[1256, 767, 1356, 1622, 1326, 1200, 415, 1324,1008, 940, 726, 1232, 560, 1670]
                }];
                this.xAxisHomeLine=this.getAutoDate(14)
                this.seriesHomeLine=[{
                    name:'收益',
                    type:'line',
                    data:[18256, 17627, 19356, 16022, 18326, 18200, 14105, 17324,18008, 19409, 15726, 19232, 15606, 16702]
                }];
                break;
                case '30':
                this.xAxisHomeLine=this.getAutoDate(30)
                this.seriesHomeLine=[{
                    name:'收益',
                    type:'line',
                    data:[12000, 14900, 17000, 12320, 12560, 17670, 13500, 16204, 13260, 18217, 16405, 11338, 12083, 14970, 14705, 12893, 18256, 17627, 19356, 16022, 18326, 18200, 14105, 17324,18008, 19409, 15726, 19232, 15606, 16702]
                }];
                this.xAxisQqHomeLine=this.getAutoDate(30)
                this.seriesQqHomeLine=[{
                    name:'侵权连接',
                    type:'line',
                    data:[200, 490, 700, 232, 256, 767, 135, 162, 326, 200, 640, 133,208, 490, 1470, 1289, 1256, 767, 1356, 1622, 1326, 1200, 415, 1324,1008, 940, 726, 1232, 560, 1670]
                }];
                break;
                default:
                break;
            }
            this.getBqChartListSy()
            this.getMonChartListQq();
        } 
    }
  },
  mounted() {
    this.init();
    var gitalk = new Gitalk({
      clientID: "a128de2dd7383614273a",
      clientSecret: "a77691ecb662a8303a6c686ae651ae035868da6e",
      repo: "hatch-comments",
      owner: "Exrick",
      admin: ["Exrick"],
      distractionFreeMode: false // 遮罩效果
    });
    // gitalk.render("comments");
    // 宣传视频
    let hatchVideo = Boolean(Cookies.get("hatchVideo"));
    if (!hatchVideo) {
      this.showVideo = true;
      Cookies.set("hatchVideo", true);
    }
  }
};
</script>
